import {StyleteqState} from "../_definitions/styleteq";
import {createSelector} from "reselect/src";
import Style from "../_data/models/Style";

export const loadingStyleSelector = (state: StyleteqState) => state.style.loading;
export const styleCommentsSelector = (state: StyleteqState) => state.style.comments;


export const myStylesSelector = (state: StyleteqState) => state.myStyles;


// WEBPACK FOOTER //
// ./app/client/style/selectors.ts